import CompareSVG from "images//icons/CompareArrow.svg"
import { eases } from "library/eases"
import { fresponsive } from "library/fullyResponsive"
import styled, { css, keyframes } from "styled-components"
import colors from "styles/colors"

export default function Compare() {
	return (
		<>
			<Side>
				<CompareArrow src={CompareSVG} alt="" />
				<Circle />
			</Side>
			<Side>
				<CompareArrow src={CompareSVG} alt="" />
				<Circle />
			</Side>
		</>
	)
}

const Circle = styled.div`
	outline: 1px solid ${colors.blue3};

	${fresponsive(css`
		width: 10px;
		height: 10px;
		border-radius: 50%;
		position: absolute;
		bottom: -5px;
		left: calc(50% - 5px);
	`)}
`

const slide = keyframes`
  13% {
    translate: 0 0;
    animation-timing-function: ${eases.back.out};
  }

  25% {
    ${fresponsive(css`
			translate: 17px 0;
		`)}
  }

  50% {
    ${fresponsive(css`
			translate: 17px 0;
		`)}
    animation-timing-function: ${eases.quad.inOut};
  }

  60% {
    translate: 0 0;
  }
`

const slideAndDisappear = keyframes`
  0% {
    opacity: 0;
  }
  12.999% {
    opacity: 0;
  }
  13% {
    opacity: 1;
    translate: 0 0;
    animation-timing-function: ${eases.back.out};
  }

  25% {
    ${fresponsive(css`
			translate: 17px 0;
		`)}
  }

  50% {
    ${fresponsive(css`
			translate: 17px 0;
		`)}
    animation-timing-function: ${eases.quad.inOut};
  }

  60% {
    translate: 0 0;
    opacity: 1;
  }
  60.001% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
`

const Side = styled.div`
	position: absolute;
	width: 44px;
	bottom: 50%;
	left: 50%;
	translate: -50% 0;
	transform-origin: bottom center;

	${Circle} {
		animation: ${slide} 8s infinite;
	}

	&:first-child {
		rotate: 180deg;
		${Circle} {
			animation: ${slideAndDisappear} 8s infinite;
		}
	}
`

const clip = keyframes`
  0% {
    clip-path: polygon(100% 0, 100% 100%, 100% 100%, 100% 0);
  }

  26% {
    clip-path: polygon(100% 0, 100% 100%, 100% 100%, 100% 0);
  }

  37% {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }

  50% {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }

  60% {
    clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
  }

  100% {
    clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
  }
`

const CompareArrow = styled.img`
	animation: ${clip} 8s infinite;

	${fresponsive(css`
		display: block;
		position: absolute;
		bottom: -8px;
		right: 0;
		width: 44px;
		height: 40px;
		max-width: unset;
		max-height: unset;
	`)}
`
